var _rect, _mask, _g, _rect2, _line, _line2, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBicycleRoadNextToRoundabout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "-100 -100 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -100,
    fill: "#707176",
    height: 200,
    width: 20
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    x: -100,
    y: -100,
    fill: "#FFF",
    mask: "url(#r)"
  }), /*#__PURE__*/React.createElement("circle", {
    x: -70,
    y: -70,
    r: 20,
    fill: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    x: -100,
    y: -100,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    x: -70,
    y: -70,
    r: 65,
    fill: "#3a4149",
    mask: "url(#r)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 60,
    x: -100,
    y: -30,
    fill: "#3a4149",
    mask: "url(#r)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 200,
    x: -30,
    y: -100,
    fill: "#3a4149",
    mask: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M 200 0     L 105 0     M 75 0     L 65 0     M 0 100     L 0 70     M 0 -100     L 0 -70",
    stroke: "#FFF",
    strokeWidth: 1,
    strokeLinecap: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    x: -100,
    y: -100,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: -27,
    y2: 27,
    stroke: "#FFF",
    strokeDasharray: "4 3",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 20,
    y1: -27,
    y2: 27,
    stroke: "#FFF",
    strokeDasharray: "4 3",
    strokeWidth: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3,40) scale(0.45)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    cx: 25,
    cy: 20,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    cx: 7,
    cy: 20,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    x1: 12,
    y1: 7,
    x2: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    points: "25,20 23,6 18,6 ",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    points: "23.7,11 9,11 7,20 ",
    strokeLinecap: "butt"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3,-60) scale(0.45)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    cx: 25,
    cy: 20,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    cx: 7,
    cy: 20,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#FFF",
    fill: "none",
    strokeMiterlimit: 10,
    x1: 12,
    y1: 7,
    x2: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    points: "25,20 23,6 18,6 ",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 10,
    points: "23.7,11 9,11 7,20 ",
    strokeLinecap: "butt"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycleRoadNextToRoundabout);
export default __webpack_public_path__ + "static/media/bicycle-road-next-to-roundabout.c8148c412bc20a53e2a5ddb4070e5cf2.svg";
export { ForwardRef as ReactComponent };